// extracted by mini-css-extract-plugin
export default {"toast":"Toast_toast__-m6I-"};